import { useId } from "react";

const RED = "#ff2b2b";
const GREEN = "#1dff7a";

const Head = ({ pid, dur, begin, r, color, filter }) => (
  <>
    {[[r * 5, 0.22], [r * 2.2, 0.95], [r * 0.9, 1]].map(([rr, op], k) => (
      <circle key={k} r={rr} fill={k === 2 ? "#ffffff" : color} opacity={op} filter={k < 2 ? filter : undefined}>
        <animateMotion dur={dur} begin={begin} repeatCount="indefinite"><mpath href={`#${pid}`} /></animateMotion>
      </circle>
    ))}
  </>
);

const Pulse = ({ pid, d, dur, begin, color, head, width, filter }) => (
  <g>
    <path id={pid} d={d} fill="none" stroke="none" />
    <path d={d} pathLength="1000" fill="none" stroke={color} strokeWidth={width} strokeLinecap="round" strokeDasharray="90 910" strokeDashoffset="1090" filter={filter}>
      <animate attributeName="stroke-dashoffset" from="1090" to="90" dur={dur} begin={begin} repeatCount="indefinite" />
    </path>
    <Head pid={pid} dur={dur} begin={begin} r={width} color={head} filter={filter} />
  </g>
);

const HERO_PATHS = [
  "M1600 -40 C1300 120 1180 380 900 520 S 300 640 -60 760",
  "M1640 0 C1340 160 1220 420 940 560 S 340 690 -60 800",
  "M1680 40 C1380 200 1260 450 980 600 S 380 730 -60 840",
  "M1560 -80 C1260 80 1140 340 860 480 S 260 600 -60 720",
  "M1700 120 C1420 260 1300 500 1020 640 S 420 770 -60 880",
];

export const FiberHero = () => (
  <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 1600 900" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
    <defs>
      <linearGradient id="fiberGrad" x1="1" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#7fe3ff" />
        <stop offset="0.5" stopColor="#2f7bff" />
        <stop offset="1" stopColor="#1438c9" />
      </linearGradient>
      <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="5" result="b" />
        <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
      </filter>
    </defs>
    {HERO_PATHS.map((d, i) => (
      <g key={i}>
        <path d={d} fill="none" stroke="url(#fiberGrad)" strokeOpacity="0.35" strokeWidth={i === 2 ? 3 : 1.6} />
        <Pulse pid={`hero-fiber-${i}`} d={d} dur={`${3.4 + i * 0.7}s`} begin={`-${i * 0.9}s`} color={i % 2 ? "#1f8bff" : "#22c4ff"} head={i % 2 ? RED : GREEN} width={i === 2 ? 4.5 : 3} filter="url(#glow)" />
      </g>
    ))}
  </svg>
);

const DIV_PATHS = [
  "M0 40 C 300 0, 500 80, 800 40 S 1300 0, 1600 40",
  "M0 50 C 320 90, 520 10, 820 50 S 1320 90, 1600 50",
  "M0 30 C 280 70, 560 -10, 840 30 S 1280 70, 1600 30",
];

export const FiberDivider = ({ dark = false, testId }) => {
  const uid = useId().replace(/:/g, "");
  return (
    <div data-testid={testId} className="relative h-20 -my-10 z-10 pointer-events-none">
      <svg className="w-full h-full" viewBox="0 0 1600 80" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <defs>
          <filter id={`dg${uid}`} x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="3" result="b" />
            <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
          </filter>
        </defs>
        {DIV_PATHS.map((d, i) => (
          <g key={i}>
            <path d={d} fill="none" stroke="#2f7bff" strokeOpacity={dark ? 0.4 : 0.25} strokeWidth="1.2" />
            <Pulse pid={`df${uid}${i}`} d={d} dur={`${5 + i * 1.3}s`} begin={`-${i * 1.7}s`} color="#45c8ff" head={i % 2 ? RED : GREEN} width={2.2} filter={`url(#dg${uid})`} />
          </g>
        ))}
      </svg>
    </div>
  );
};
